<div
  *ngIf="item"
  class="row form-property  {{
    property?.styleClass ? property.styleClass : ''
  }}"
>
  <div
    class="col-lg-{{ tooltip ? 10 : 12 }}"
    [ngClass]="{ 'no-padding-right': tooltip }"
  >
    <span class="p-float-label">
      <p-multiSelect
        #multiLocationSelect
        [appendTo]="'body'"
        id="{{ name }}"
        [options]="options"
        optionDisabled="disabled"
        (onChange)="change($event)"
        (onPanelShow)="onMultiSelectPanelShow()"
        (onPanelHide)="onMultiSelectPanelHide()"
        [showToggleAll]="false"
        [ngModel]="value"
        [readonly]="readonly"
        [ngClass]="{
          disabled: readonly,
          'multiselect-property-invalid': notValid
        }"
        class="disabled ui-inputwrapper-focus ui-inputwrapper-focus"
        [scrollHeight]="panelHeight"
        [style]="{ width: '100%' }"
        [panelStyle]="{ 'max-height': '400px', 'min-width': '400px' }"
        [defaultLabel]="property.defaultLabel"
        [virtualScroll]="true"
        [virtualScrollItemSize]="scrollItemHight"
        [selectedItemsLabel]="'{0} locations selected'"
        [maxSelectedLabels]="1"
      >
        <ng-template let-opt pTemplate="item">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 12px;
              width: 100%;
            "
          >
            <span
              [pTooltip]="opt.label"
              tooltipPosition="top"
              style="flex: 1; padding-left: 6px"
            >
              {{ opt.label | truncate }}
            </span>

            <!-- DatePicker (expiresAt) -->
            <div
              (mousedown)="onCalendarWrapperClick($event)"
              (click)="onCalendarWrapperClick($event)"
              style="display: inline-block; max-width: 110px;"
            >
              <p-calendar
                #excludeUntilDate
                [disabled]="isCalendarDisabled(opt)"
                [(ngModel)]="opt.value.expiresAt"
                (ngModelChange)="dateUpdated($event)"
                dateFormat="mm/dd/yy"
                pTooltip="Set excluded until date (optional)"
                tooltipPosition="left"
                [showClear]="true"
                [appendTo]="'body'"
                (onSelect)="onSelect($event)"
                (onShow)="onCalendarShow()"
                (onClose)="onCalendarClose($event)"
              ></p-calendar>
            </div>
          </div>
        </ng-template>
      </p-multiSelect>
      <label
        class="gs-float-label {{
          property?.labelClass ? property.labelClass : ''
        }}"
        [ngClass]="{ 'error-color': notValid }"
      >
        {{ label }}
      </label>
      <span
        *ngIf="notValid"
        class="form-error"
        pTooltip="{{ property.validationMessage }}"
        tooltipPosition="top"
      >
        <i
          class="fas fa-info-circle fa-2x form-valid-icon with-icon error-color"
        ></i>
      </span>
    </span>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{ property.tooltip }}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
